import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';
import CanvasFormInputDisplay from '../../../../Common/CanvasForm/CanvasFormInputDisplay';
import CanvasFormInputValue from '../../../../Common/CanvasForm/CanvasFormInputValue';

export const PrintViewMultiLineInputBody = ({body}) => {
	const {bodyFreeText, label, name} = body;

	return (
		<StyledPrintViewMultiLineInputBody className="StyledPrintViewMultiLineInputBody">
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={name} />}
			<CanvasFormInputDisplay bodyFreeText={bodyFreeText} value={bodyFreeText} label={label} isReadOnly>
				<CanvasFormInputValue />
			</CanvasFormInputDisplay>
		</StyledPrintViewMultiLineInputBody>
	);
};

PrintViewMultiLineInputBody.propTypes = {
	body: PropTypes.shape({
		bodyFreeText: PropTypes.string,
		label: PropTypes.string,
		name: PropTypes.string
	})
};

PrintViewMultiLineInputBody.defaultProps = {};

export default PrintViewMultiLineInputBody;

const StyledPrintViewMultiLineInputBody = styled.section`
	.StyledPrintViewKnowledgeDescription {
		margin-bottom: var(--px-10);
	}
	.canvas-form-input-display {
		padding: var(--px-2) var(--px-8);
		border: 1px solid var(--neutrals-300);
		font-size: var(--px-12);
	}
`;
